// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  cloneInventory,
  createInventory,
  deleteInventory,
  exportInventory,
  getDetailInventory,
  getListInventoryHistory,
  getListInventoryProduct,
  getListInventoryQuote,
  importInventory,
  updateInventory,
} from './inventoryThunk';

export interface IInventoryState {
  isRefreshInventoryList: boolean;
  isRefreshInventoryDetail: boolean;
}

export const initialState: IInventoryState = {
  isRefreshInventoryList: false,
  isRefreshInventoryDetail: false,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setRefreshInventoryList(state, action) {
      state.isRefreshInventoryList = action.payload;
    },
    setRefreshInventoryDetail(state, action) {
      state.isRefreshInventoryDetail = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list inventory quote
    builder
      .addCase(getListInventoryQuote.pending, (_state) => {})
      .addCase(getListInventoryQuote.fulfilled, (_state) => {})
      .addCase(getListInventoryQuote.rejected, (_state) => {});

    // GET: Get list inventory product
    builder
      .addCase(getListInventoryProduct.pending, (_state) => {})
      .addCase(getListInventoryProduct.fulfilled, (_state) => {})
      .addCase(getListInventoryProduct.rejected, (_state) => {});

    // GET: Get list inventory history
    builder
      .addCase(getListInventoryHistory.pending, (_state) => {})
      .addCase(getListInventoryHistory.fulfilled, (_state) => {})
      .addCase(getListInventoryHistory.rejected, (_state) => {});

    // GET: Get detail inventory
    builder
      .addCase(getDetailInventory.pending, (_state) => {})
      .addCase(getDetailInventory.fulfilled, (_state) => {})
      .addCase(getDetailInventory.rejected, (_state) => {});

    // POST: Create inventory
    builder
      .addCase(createInventory.pending, (_state) => {})
      .addCase(createInventory.fulfilled, (_state) => {})
      .addCase(createInventory.rejected, (_state) => {});

    // POST: Import inventory
    builder
      .addCase(importInventory.pending, (_state) => {})
      .addCase(importInventory.fulfilled, (_state) => {})
      .addCase(importInventory.rejected, (_state) => {});

    // DELETE: Delete inventory
    builder
      .addCase(deleteInventory.pending, (_state) => {})
      .addCase(deleteInventory.fulfilled, (_state) => {})
      .addCase(deleteInventory.rejected, (_state) => {});

    // PUT: Update inventory
    builder
      .addCase(updateInventory.pending, (_state) => {})
      .addCase(updateInventory.fulfilled, (_state) => {})
      .addCase(updateInventory.rejected, (_state) => {});

    // GET: Export inventory
    builder
      .addCase(exportInventory.pending, (_state) => {})
      .addCase(exportInventory.fulfilled, (_state) => {})
      .addCase(exportInventory.rejected, (_state) => {});

    // POST: Clone inventory
    builder
      .addCase(cloneInventory.pending, (_state) => {})
      .addCase(cloneInventory.fulfilled, (_state) => {})
      .addCase(cloneInventory.rejected, (_state) => {});
  },
});

// Action
export const inventoryActions = inventorySlice.actions;

// Selectors
export const selectIsRefreshListInventory = (state: RootState) => state.inventory.isRefreshInventoryList;
export const selectIsRefreshDetailInventory = (state: RootState) => state.inventory.isRefreshInventoryDetail;

// Reducer
const inventoryReducer = inventorySlice.reducer;
export default inventoryReducer;
